import { EntityType } from '../../../workflow-sidebar/edit-node-form/nodes/enroll-node-editor/enroll-node-editor.types';

export const getEntityOptionDisplayLabel = (entity: { label: string; value: string }): string => {
  const trimmed = (entity.label ?? '').trim();
  return trimmed.length > 0 ? trimmed : entity.value;
};

export const formatEntityType = (entityType?: EntityType) => {
  switch (entityType) {
    case 'branchOfficeIds':
      return 'Branch Office';
    case 'jobTypeIds':
      return 'Job Type';
    default:
      return entityType;
  }
};

export const formatConditionsText = (condition: string) => {
  return condition === 'equal' ? '=' : condition;
};
